const pages = {
	group: (id: number | string) => `/settings/groups/${id}`,
	editRule: (ruleId: number | string) => `/rules/${ruleId}`,
	groupManagement: "/settings/groups",
	groupPlugins: (groupId: number | string) => `/settings/groups/${groupId}/plugins`,
	groupRules: (groupId: number | string) => `/settings/groups/${groupId}/rules`,
	groupSSO: (groupId: number | string) => `/settings/groups/${groupId}/sso`,
	groupUsers: (groupId: number | string) => `/settings/groups/${groupId}/users`,
	home: "/rules/library",
	login: "/",
	newRuleBuilder: "/new-rule",
	organizationManagement: "/settings/organization",
	pluginGroups: (id: number | string) => `/settings/plugins/${id}/groups`,
	pluginHome: (id: number | string) => `/settings/plugins/${id}`,
	pluginManagement: "/settings/plugins",
	profile: "/settings/users/",
	role: (id: number | string) => `/settings/roles/${id}`,
	rolePermissions: (roleId: number | string) => `/settings/roles/${roleId}/permissions`,
	roleUsers: (roleId: number | string) => `/settings/roles/${roleId}/users`,
	roleSSO: (roleId: number | string) => `/settings/roles/${roleId}/sso`,
	roleManagement: "/settings/roles",
	scimWizard: "/settings/organization/sso-scim",
	userManagement: "/settings/users",
	workstationManagement: "/settings/workstations",
	collectionManagement: "/settings/collections",
	collection: (id: number | string) => `/settings/collections/${id}`,
};

export default pages;
